import { render, staticRenderFns } from "./ValidationMessage.vue?vue&type=template&id=0cc6fa26"
import script from "./ValidationMessage.vue?vue&type=script&lang=js"
export * from "./ValidationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports